import React, { Component } from 'react';
import animations from './animations';
import Heading from "../../elements/Heading";

class Supporting extends Component {

    constructor(props) {
        super(props);

        this.sceneController = null;
        this.desktopTabs = [];
        this.desktopBlocks = [];
        this.mobileBlocks = [];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            if (!this.sceneController) {
                this.sceneController = animations.initialise(this);
            }
        }
    }

    componentWillUnmount() {
        if (this.sceneController) {
            animations.destroy(this.sceneController);
        }
    }

    setTitleRef(el) {
        this.titleRef = el;
    }

    setSubTitleRef(el) {
        this.subTitleRef = el;
    }
    
    render() {
        return (
            <section className="proudly-supporting">
                <div className="inner">
                    <div className="row">
                        <div className="col-md-4 col-sm-offset-1 col-xl-offset-2 col-sm-12 text-sm-center text-xs-center">
                            <Heading
                                title={this.props.data.title}
                                subTitle={this.props.data.subTitle}
                                setTitleRef={this.setTitleRef.bind(this)}
                                setSubTitleRef={this.setSubTitleRef.bind(this)}
                            >
                                <p>{this.props.data.content}</p>
                            </Heading>
                        </div>
                    </div>
                    <div className="d-block d-md-none bg-mobile">
                        <img src="/images/koala.svg" alt="Exetel koala support" />
                    </div>
                    <div className="spacer" />
                </div>
                <div className="bg d-none d-md-block" />
                <div className="careers-trigger" />
            </section>
        );   
    }
    
}

export default Supporting;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Supporting/Supporting.js